<template>
  <div class="left">
    <LeftMenu active="VideoSurveillance" :warning-total="warningTotal"/>
    <div class="video-con">
      <video-container v-if="token && type === 0" :info="info" :token="token"></video-container>
      <video-da-hua v-if="token && type === 1" :info="info"></video-da-hua>
    </div>
  </div>
</template>

<script>
import LeftMenu from "../../components/LeftMenu";
import videoContainer from "../../../home/components/videoContainer";
import videoDaHua from "../../../home/components/videoDaHua";
export default {
  name: "BottomLeft",
  components: { videoContainer, LeftMenu, videoDaHua },
  props: {
    type: { type: Number, default: 0 }, // 0海康， 1大华
    info: { type: Object, default: () => {} },
    token: { type: String, default: '' },
    warningTotal: { type: Number, default: 0 }
  },
  data () {
    return {}
  }
}
</script>

<style scoped lang="less">
.left {
  background-image: url("../../../../assets/dp/bottom-left.png");
  background-size: 100% 100%;
  display: flex;
  height: calc(100% - 20px);
  overflow: auto;
  padding-top: 20px;
  .video-con{
    width: calc(100% - 96px);
    height: calc(100% - 40px);
    overflow-y: auto;
    padding: 0 20px 20px 0;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
}
</style>
